module.exports = __webpack_public_path__ + "img/l31.58e773b1.jpg";